import styled from 'styled-components';
import { getSpacingToken, getToken, WithChildren } from '@optimus-web/common';
import { LocalizedMajorHighlight } from '@mews-commander/ui';
import { MEDIA_QUERY, Stack } from '@optimus-web/core';

interface OrderedListItemProps extends WithChildren {
    idx: number;
    labelKey?: Mews.TextKey;
}

const ListItem = styled.li`
    display: flex;
    align-items: flex-start;
    margin-bottom: ${getSpacingToken('500')}px;

    &:last-of-type {
        margin-bottom: 0;
    }
    ${MEDIA_QUERY.tabletMax} {
        flex-direction: column;
    }
`;

const OrderNumber = styled(Stack)`
    height: 60px;
    min-width: 60px;
    font-size: ${getToken('fontSize500')}px;
    font-weight: ${getToken('fontWeight400')};
    color: ${getToken('paletteBrandIndigo300')};
    border: 1.5px solid ${getToken('paletteBrandIndigo300')};
    border-radius: ${getToken('borderRadiusRound')};
    margin-right: ${getSpacingToken('300')}px;

    ${MEDIA_QUERY.tabletMax} {
        margin-bottom: ${getSpacingToken('300')}px;
        margin-right: 0;
    }
`;

export const OrderedListItem: React.FC<OrderedListItemProps> = ({ idx, labelKey, children }) => (
    <ListItem>
        <OrderNumber alignment="center" itemAlignment="center">
            {idx + 1}
        </OrderNumber>
        <Stack spacing="200" vertical>
            {labelKey && <LocalizedMajorHighlight textKey={labelKey} />}
            {children}
        </Stack>
    </ListItem>
);
